import React from 'react';

import DocumentTitle from 'bz-core-controls/controls/document-title';
import Fallback from 'bz-core-controls/controls/lazy/controls/fallback';
import { DialogStoreProvider } from 'bz-stores/mobx/dialog-store';
import { asInt } from 'bz-utilities/functions/parse';
import { useApiQuery } from 'bz-utilities/hooks/api';
import history from 'bz-utilities/modules/networking/history/rr4';
import { VehicleRequest } from 'features/gds/gds.dtos';
import { observer } from 'mobx-react';
import { Redirect, Route, Switch, useParams } from 'react-router';
import Paths from './paths';
const VehiclesDesktop = React.lazy(() => import('../desktop'));
const JobSheetDesktop = React.lazy(() => import('../../work-sheets/job-sheets/desktop'));
// const JobSheetDetails = React.lazy(() => import('../../work-sheets/job-sheets/details'));
const SMRDesktop = React.lazy(() => import('../../smr/desktop'));

export interface IParams {
  id: string;
}
export interface IProps {}

const VehiclesSwitch: React.FC<IProps> = observer(() => {
  return (
    <DialogStoreProvider>
      <>
        <DocumentTitle title="TM3 > Vehicles" />
        <React.Suspense fallback={<Fallback />}>
          <Switch>
            <Redirect path={Paths.jobsheets.cloneRedirect} to={Paths.jobsheets.details} />
            <Route exact path={[Paths.smr.index, Paths.smr.details]} component={SMRDesktop} />
            <Route
              exact
              path={[Paths.jobsheets.index, Paths.jobsheets.add]}
              component={JobSheetDesktop}
            />
            {/* <Route path={Paths.jobsheets.details} component={JobSheetDetails} /> */}
            <Route
              exact
              path={[Paths.vehicles.index, Paths.vehicles.add]}
              component={VehiclesDesktop}
            />
            <Route path={Paths.vehicles.details.index} component={RedirectToCustomerVehicle} />
          </Switch>
        </React.Suspense>
      </>
    </DialogStoreProvider>
  );
});

function RedirectToCustomerVehicle() {
  const { id } = useParams<{ id: string }>();
  const { data: res } = useApiQuery(new VehicleRequest({ id: asInt(id) }), 'get');
  if (res) {
    const { result: vehicle } = res;
    history.push(`/contacts/{patients}/${vehicle.customerId}/vehicles/${vehicle.id}`);
  }
  return null;
}

export default VehiclesSwitch;
